import { Cellstyle, ClickableCell } from "~app/common/components/hot-doc/hotdoc/cell";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";

export class AddEditLengthCell extends ClickableCell {

    constructor(flags?: Cellstyle, settings?: any, private readonly icon?: string, private readonly onHandle?: () => void) {
        super(flags, settings);
    }

    onClick = (hotDoc: HotDoc): void => {
        if (this.onHandle) {
            this.onHandle();
        }
    };

    protected genHtml(): string {
        return `<button class='btn btn-icon icon-btn accordion-trigger' style="line-height:0" type='button' ignore-readonly>` +
            `<i class="${this.icon ? this.icon : "fas fa-edit"}"></i>` +
            `</button>`;
    }
}
